export const ADD_BUILDING = 'ADD_BUILDING'
export const DELETE_BUILDING = 'DELETE_BUILDING'
export const SET_BUILDING = 'SET_BUILDING'
export const SET_BUILDINGS = 'SET_BUILDINGS'
export const RESET_BUILDING = 'RESET_BUILDING'



// WEBPACK FOOTER //
// ./src/store/modules/building/types.js